import { StyledLink } from "@/styles/Styled.Typography";
import * as StyledFoot from "./Styled.Foot";

const Footer = () => {
  return (
    <StyledFoot.FooterLayoutWrapper>
      <StyledFoot.FooterNavWrapper>
        <StyledFoot.FooterNav aria-label="Footer primary" as="ul">
          <li>
            <StyledFoot.NavLinks to="/resources">Resources</StyledFoot.NavLinks>
          </li>
          <li>
            <a href="https://stanleyyeo.gumroad.com/">Shop</a>
          </li>
        </StyledFoot.FooterNav>
      </StyledFoot.FooterNavWrapper>
      <StyledFoot.UtilityNavWrapper>
        <StyledFoot.UtilityNav as="ul" aria-label="Utility">
          <li>&copy; {new Date().getFullYear()} Stanley Yeo</li>
          <li>
            <StyledFoot.NavLinks to="/privacy/">Privacy</StyledFoot.NavLinks>
          </li>
        </StyledFoot.UtilityNav>
        <StyledFoot.SocialNav as="ul" aria-label="Social">
          <li>
            <a href="https://sg.linkedin.com/in/stanleyyeo">LinkedIn</a>
          </li>
          <li>
            <a href="https://twitter.com/imstanleyyeo">X (Twitter)</a>
          </li>
          <li>
            <a href="https://www.instagram.com/imstanleyyeo/">Instagram</a>
          </li>
        </StyledFoot.SocialNav>
      </StyledFoot.UtilityNavWrapper>
    </StyledFoot.FooterLayoutWrapper>
  );
};

export default Footer;
